// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAlertOutlinedSvg from "@fishx/icons-svg/es/asn/PAlertOutlined";
import FishxIcon from '../components/FishxIcon';

var PAlertOutlined = function PAlertOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAlertOutlinedSvg
  }));
};

PAlertOutlined.displayName = 'PAlertOutlined';
export default React.forwardRef(PAlertOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAlertOutlined.js
// module id = 3200
// module chunks = 0